import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

function AssignAccount() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [agents, setAgents] = useState([]);
  const [investors, setInvestors] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [fetched, setFetched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [touched, setTouched] = useState({
    admin_id: false,
    acname: false,
    statuss: false,
  });

  const [formData, setFormData] = useState({
    id: "",
    acno: "",
    acname: "",
    aadharno: "",
    admin_name: "",
    admin_id: "",
    statuss: "",
    id: "",
    acid: "",
    investorid: "",
  });
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setTouched({
      acname: false,
      admin_id: false,
      statuss: false,
    });
    if (!isModalOpen && !isEditMode) {
      const emptyData = {
        id: "",
        image: "",
        acno: "",
        acname: "",
        aadharno: "",
        admin_name: "",
        admin_id: "",
        statuss: "",
        acid: "",
        investorid: "",
      };

      setFormData(emptyData);
      setErrors({});
    }
  };

  const handleDropdownClick = () => {
    if (!fetched) {
      const accessToken = sessionStorage.getItem("access_token");
      axios
        .get(`${baseURL}/getAllAdmin`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          setAgents(response.data);
          setFetched(true);
        });
    }
  };

  const handleDropdownClickInvestor = () => {
    if (!fetched) {
      const accessToken = sessionStorage.getItem("access_token");
      axios
        .get(`${baseURL}/getAllInvestor`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          setInvestors(response.data);
          setFetched(true);
        });
    }
  };

  useEffect(() => {
    if (!fetched) {
      handleDropdownClick();
    }

    handleDropdownClickInvestor();

    fetchItems();
  }, []);

  const validateField = (name, value) => {
    let error = "";
    if (touched[name] && !value) {
      error = "Required";
    }

    if (name === "acname" && !value) {
      error = "Required";
    }

    if (name === "admin_id" && !value) {
      error = "Required";
    }

    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));

    
    const error = validateField(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const fetchItems = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getAllAccount`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The user has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteCustomer`, {
        data: { id: id },
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });

      if (response.status === 200) {
        setItems(items.filter((item) => item.id !== id));
      } else {
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",

          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const updateData = (id) => {
    const item = items.find((item) => item.id === id);
    console.log("item : ", item);
    if (item) {
      setFormData({
        aadharno: item.aadharno,
        acno: item.acno,
        contactno: item.contactno,
        statuss: item.statuss,

        id: item.id,
      });
      console.log("Agents : ", agents);

      const selectedAgent = agents.find((agent) => agent.id == item.admin_id);
      console.log("Selected Agent : ", selectedAgent);
      setFormData((prevData) => ({
        ...prevData,
        admin_id: selectedAgent.id,
        aadharno: selectedAgent.aadhar_no,
      }));
      const selectedInvestor = investors.find(
        (investor) => investor.id == item.investor_id
      );
      console.log("Selected Investor : ", selectedInvestor);

      setFormData((prevData) => ({
        ...prevData,
        acname: selectedInvestor.id,
        acno: selectedInvestor.acno,
      }));

      console.log("Updating data for Assign Account:", item);
      setIsEditMode(true);
      setIsModalOpen(true);
    }
  };

  const handleEdit = async () => {
    console.log("Form Data before update:", formData); // Debugging line
    setIsSubmitted(true);
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.put(`${baseURL}/updateAccount`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Account updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
        fetchItems();
        toggleModal();
        setIsEditMode(false);
      } else {
        console.error("Error updating account:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };
  const handleInvestorChange = (e) => {
    const selectedAcname = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      acname: selectedAcname,
      acno: "",
      investorid: "",
    }));
    console.log("Selected Investor : ", selectedAcname);

    const selectedInvestor = investors.find(
      (investor) => investor.id == selectedAcname
    );

    if (selectedInvestor) {
      console.log("Selected Investor:", selectedInvestor);
      setFormData((prevData) => ({
        ...prevData,
        acname: selectedInvestor.id,
        acno: selectedInvestor.acno,
        investorid: selectedInvestor.id,
      }));
    }
  };

  const handleAdminChange = (e) => {
    const selectedAdminId = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      admin_id: selectedAdminId,
      aadharno: "",
      acid: "",
    }));

    const selectedAgent = agents.find((agent) => agent.id == selectedAdminId);

    if (selectedAgent) {
      console.log("Selected Agent:", selectedAgent);
      setFormData((prevData) => ({
        ...prevData,
        aadharno: selectedAgent.aadhar_no,
        acid: selectedAgent.id,
        admin_id: selectedAgent.id,
      }));
    }
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);

    setTouched({
      admin_id: true,
      acname: true,
      statuss: true,
    });

    console.log("Form submission started");
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }
    console.log("Validation errors:", newErrors);
    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      console.log("Form validation failed. Submission aborted.");
      return;
    }

    const selectedAdmin = agents.find(
      (agent) => agent.id === formData.admin_id
    );
    const updatedFormData = {
      ...formData,
      admin_name: selectedAdmin ? selectedAdmin.name : "",
    };

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.post(`${baseURL}/insertAccount`, updatedFormData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      Swal.fire({
        icon: "success",
        text: "Account added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
      toggleModal();
      fetchItems();
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const filteredItems = items.filter(
    (item) =>
      (item.acname && item.acname.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.admin_id && item.admin_id.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.acno && item.acno.includes(searchQuery)) ||
      (item.aadharno && item.aadharno.includes(searchQuery))
  );

 
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Assign Account</h2>

        {/* Table */}

        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              <label className="md:text-sm">Show</label>
              <select
                className="border border-gray-300 rounded p-1"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option className="md:text-xs" value="10">
                  10
                </option>
                <option className="md:text-xs" value="25">
                  25
                </option>
                <option className="md:text-xs" value="50">
                  50
                </option>
              </select>
              <span>entries</span>
            </div>
            <div className="flex items-center space-x-4 overflow-y-auto">
              <button
                onClick={() => {
                  setIsEditMode(false);
                  toggleModal();
                }}
                className="bg-green-500 text-white px-4 py-2 rounded w-full sm:w-auto"
              >
                Assign Account
              </button>
              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        {isEditMode ? "Update Account" : "Add Account"}
                      </h2>
                      <button
                        onClick={() => {
                          setIsEditMode(false);
                          toggleModal();
                        }}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <div className="max-h-[70vh] overflow-y-auto p-2">
                      <form className="space-y-4">
                        <div className="flex flex-col items-center mb-6"></div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="block text-gray-600">
                              Agent Name<span className="text-red-500">*</span>{" "}
                            </label>
                            <select
                              name="admin_id"
                              required
                              value={formData.admin_id || ""}
                              onChange={(e) => {
                                handleInputChange(e);
                                handleAdminChange(e);
                              }}
                              onClick={handleDropdownClick}
                              className={`border p-2 w-full ${
                                errors.admin_id && touched.admin_id
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                            >
                              <option value="" disabled selected>
                                Select the agent
                              </option>
                              {agents.length > 0 ? (
                                agents.map((agent) => (
                                  <option key={agent.admin_id} value={agent.id}>
                                    {agent.name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>No agents available</option>
                              )}
                            </select>
                            {errors.admin_id && touched.admin_id && (
                              <span className="text-red-500 text-sm">
                                {errors.admin_id}
                              </span>
                            )}
                          </div>

                          <div>
                            <label className="block text-gray-600">
                              Aadhar No.
                            </label>
                            <input
                              type="text"
                              name="aadharno"
                              value={formData.aadharno || ""}
                              readOnly
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Investor Name
                              <span className="text-red-500">*</span>{" "}
                            </label>
                            <select
                              name="acname"
                              required
                              value={formData.acname || ""}
                              onChange={(e) => {
                                handleInvestorChange(e);
                                handleInputChange(e);
                              }}
                              onClick={handleDropdownClickInvestor}
                              className={`border p-2 w-full ${
                                errors.acname && touched.acname
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                            >
                              <option value="">Select the investor</option>
                              {investors.length > 0 ? (
                                investors.map((investor) => (
                                  <option
                                    key={investor.acname}
                                    value={investor.id}
                                  >
                                    {investor.acname}
                                  </option>
                                ))
                              ) : (
                                <option disabled>No agents available</option>
                              )}
                            </select>
                            {errors.acname && touched.acname && (
                              <span className="text-red-500 text-sm">
                                {errors.acname}
                              </span>
                            )}
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Account Number{" "}
                            </label>
                            <input
                              type="text"
                              name="acno"
                              value={formData.acno || ""}
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          {isEditMode && (
                          <div>
                            <label className="block text-gray-600">
                              Status
                            </label>
                            <select
                              name="statuss"
                              value={formData.statuss || ""}
                              onChange={handleInputChange}
                              className="border p-2 w-full border-gray-300"
                            >
                              <option>Mark the status</option>
                              <option>Active</option>
                              <option>Inactive</option>
                            </select>
                          </div>
                        )}
                          
                     
                        </div>
                        <div className="flex justify-end mt-4 space-x-2">
                          
                          <button
                            type="button"
                            onClick={() => {
                              toggleModal();
                              setIsEditMode(false);
                            }}
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                          >
                            Close
                          </button>
                          <button
                            onClick={() => {
                              if (isEditMode) {
                                handleEdit();
                              } else {
                                handleSubmit();
                                setIsEditMode(false);
                              }
                            }}
                            type="button"
                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                          >
                            {isEditMode ? "Update" : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Search"
                  className="border border-gray-300 rounded p-1  w-full sm:w-auto"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Table Content */}
          <div className="flex flex-col h-screen">
            <div className="overflow-x-auto">
              <table className="w-full text-left   border-collapse text-sm sm:text-xs md:text-sm lg:text-base">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2">Id</th>
                    <th className="p-2">Aadhar No.</th>
                    <th className="p-2">Name</th>
                    <th className="p-2">Account No.</th>
                    <th className="p-2">Account Name</th>
                    <th className="p-2">Status</th>
                    <th className="p-2">Options</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item) => {
                    return (
                      <tr key={item.id} className="border-b">
                        <td className="p-2">{item.id}</td>

                        <td className="p-2">{item.aadharno || "--"}</td>
                        <td className="p-2">{item.admin_name || "--"}</td>
                        <td className="p-2">{item.acno || "--"}</td>
                        <td className="p-2">{item.acname || "--"}</td>
                        <td className="p-2">{item.statuss || "--"}</td>

                        <td className="p-2 space-x-3">
                          <button
                            onClick={() => updateData(item.id)}
                            className="text-blue-500"
                          >
                            <i className="fas fa-edit"></i>
                          </button>

                          <button
                            onClick={() => handleDelete(item)}
                            className="text-red-500"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="flex justify-between items-center mt-4">
                <p>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {indexOfLastItem > items.length
                    ? items.length
                    : indexOfLastItem}{" "}
                  of {items.length} entries
                </p>
                <div className="flex space-x-2">
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages).keys()].map((num) => (
                    <button
                      key={num}
                      className={`border px-2 py-1 rounded ${
                        currentPage === num + 1 ? "bg-blue-500 text-white" : ""
                      }`}
                      onClick={() => handlePageChange(num + 1)}
                    >
                      {num + 1}
                    </button>
                  ))}
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AssignAccount;
